import React, { useState, useEffect } from 'react';

// import imageSuccess from '../../img/success.svg';

export const StepError = () => {

    return <div className="m-form__step m-form__step--confirm">
        <div className="m-form__container">
            <div className="m-form__icon"></div>
            <h2 className="m-form__header">Problem z potwierdzeniem</h2>
            <p className="m-form__content">
                Sprawdź czy link nie stracił ważności.
            </p>
        </div>
    </div>
}

